import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fleet-settings',
  templateUrl: './fleet-settings.component.html',
  styleUrls: ['./fleet-settings.component.scss']
})
export class FleetSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }


  
  ExpenseCat = [
    {
        "CategoryName": "Fuel",
        "Description": "Petrol/Diesel"
    },
    {
      "CategoryName": "Mechanic",
      "Description": "Service work"
   },
   {
    "CategoryName": "Insurance",
    "Description": "Insurance"
  }
  ]


}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/fleet-management/fleet-settings/fleet-settings.component.ts